import { render, staticRenderFns } from "./main_search.vue?vue&type=template&id=007b5c1d&scoped=true&"
import script from "./main_search.vue?vue&type=script&lang=js&"
export * from "./main_search.vue?vue&type=script&lang=js&"
import style0 from "./main_search.vue?vue&type=style&index=0&id=007b5c1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007b5c1d",
  null
  
)

export default component.exports